import { render, staticRenderFns } from "./ColorVariation.vue?vue&type=template&id=7c728964"
import script from "./ColorVariation.vue?vue&type=script&lang=js"
export * from "./ColorVariation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports